class Storage {
  static set(name, value) {
    localStorage.setItem(name, value);
  }

  static get(value) {
    return localStorage.getItem(value);
  }

  static remove(name) {
    return localStorage.removeItem(name);
  }
}

export default Storage;
